/* global define BASE_PLUGIN_URL BASE_AMP_URL s_md screenfull */
import { extend, throttle, get }                 from 'lodash';
import Reflux                                    from 'reflux';
import { browserHistory }                        from 'react-router';
import { isMobile, isIpad, imageServer, envCheck,
                             isLocal }           from 'utils/util';
import VideoApi                                  from 'video/video-api';
import videoConfig                               from 'video/config';
import MediaStore                                from 'mixins/media_store';
import StoreState                                from 'mixins/store_state';
import VideoActions                              from 'actions/video_actions';
import DescriptorStore                           from 'stores/descriptor_store';
import HasPrettyTime                             from 'mixins/has_pretty_time';


export default Reflux.createStore({
  listenables: VideoActions,
  mixins: [ StoreState, MediaStore, HasPrettyTime ],
  stateNamespace: 'video',
  queued: [ ],
  getInitialState() {
    return {
      isVideo: true,
      hasStarted: false
    };
  },
  onLoad(elementId, video) {
    const descriptor = DescriptorStore.getDescriptor(),
          ampPath    = '/amp-premier/',
          pluginPath = `${ampPath}plugins/`,
          ampURL     = isLocal()? ampPath : `http://img${envCheck()}.medscape.com/pi/core${ampPath}`,
          pluginURL  = isLocal()? pluginPath : `http://img${envCheck()}.medscape.com/pi/core${pluginPath}`,
          watermark  = descriptor.watermark ? descriptor.watermark:'',
          config     = extend(videoConfig(pluginURL, ampURL), {
            media: video,
            debug: false,
            autoplay: video.autoplay,
            playsinline: true,
            controls: {
              'native': (isMobile() && !isIpad()),
               mode: (isMobile() && !isIpad()) ? 'auto' : 'none'
            },
            branding: {
              id: 'logo',
              logo: watermark
            },
            playoverlay: { enabled: true  },
            captioning:  { enabled: !(isMobile() && !isIpad()) },
            webmd: {
              chapterData: descriptor.videos[descriptor.videos.findIndex((inVideo)=>inVideo === video)].chapters
            },
            mode: 'html'
          });
    config.flash        = config.flash || { };
    config.flash.params = { wmmode: 'transparent' };
    if(this.mediaApi) {
      this.removeMediaEvents();
      this.mediaApi.destroy();
      if(document.getElementById('captions') !== null) {
        document.getElementById('captions').parentNode.removeChild(document.getElementById('captions'));
      }
      const videoEl = document.getElementById(elementId);
      videoEl.removeAttribute('crossorigin');
      while (videoEl.firstChild) {
          videoEl.removeChild(videoEl.firstChild);
      }
    }
    this.mediaApi = new VideoApi(elementId, config);
    this.mediaApi.init(() => {
      this.mediaApi._v.setAutoplay(config.autoplay && !this.state.stopAutoplay);
      this.addMediaEvents();
    });
    this.mediaApi.ready(this.onReady.bind(this));
    this.setState({
            meta: video,
           index: descriptor.videos.findIndex((inVideo)=>inVideo === video),
           event: 'loading',
       isLoading: false,
          viewed: { },
      playerType: this.mediaApi._v.getPlayerType()
    });
    this.mediaApi._v.getMediaElement().addEventListener('touchend', ()=> {
      if(document.getElementById('tvPlayer').classList.contains('presistant-video')) {
        if(this.mediaApi._v.getMediaElement().paused) {
          this.mediaApi._v.getMediaElement().play();
        } else {
          this.mediaApi._v.getMediaElement().pause();
        }
      }
    });
    // DEBUG REMOVEME
    window.mediaApi = this.mediaApi;
    this.time = false;
  },
  exitFullScreenMobile() {
    if(!isIpad() && isMobile()) {
      this.mediaApi.exitFullScreen();
      this.mediaApi._v.getMediaElement().setAttribute('controls', '');
    }
  },
  loadMobileCC(index) {
    if((isMobile() && !isIpad())) {
      const   ccArray =  DescriptorStore.getCCArray(index),
            ccEnabled = DescriptorStore.hasCCEnabled(index),
         videoElement = this.mediaApi._v.getMediaElement();

      ccArray.forEach((ccInfo, i)=> {
        const key      = Object.keys(ccInfo)[0],
              ccFileName = ccInfo[key];
        if(typeof ccFileName !== 'undefined' && ccEnabled === true) {
          const trackUrl     = `${imageServer(envCheck())}/${DescriptorStore.getCCFileRoot(index).replace(/^en\//, '')}${ccFileName}`.replace('.xml', '.vtt'),
                track        = document.createElement('track');
          videoElement.setAttribute('crossorigin', 'anonymous');
          this.ccLoaded = true;
          track.kind    = 'captions';
          track.srclang = key;
          track.label   = key;
          track.src     = trackUrl;
          track.id      = `caption-${key}`;
          if(document.getElementById(`caption-${key}`) === null) {
            videoElement.appendChild(track);
            if(i === 0) {
              videoElement.mode = 'showing';
              videoElement.textTracks[i].mode = 'showing';
            } else {
              videoElement.textTracks[i].mode = 'hidden';
            }
          }
        }
      });
    }
  },
  getInitDuration(meta) {
    if(get(meta, 'duration', false)) {
      return meta.duration;
    } else {
      return this.mediaApi.getDuration() || 0;
    }
  },
  onReady() {
    if(!isMobile() && !isIpad()) {
      this._setupFullScreenIdleDetection();
    }
    const meta = DescriptorStore.getVideo(this.state.index);
    this._isReady = true;
    this.setState({
               index: this.state.index,
                 api: this.mediaApi,
               event: 'ready',
           isLoading: false,
         isBuffering: false,
           isPlaying: false,
         currentTime: this.mediaApi.getCurrentTime(),
            duration: this.getDuration(meta),
                meta: meta,
      isCaptioningOn: get(meta, 'hasCcAutoDisplay', false),
              ccLang: get(meta, 'ccDefaultLang', 'en'),
          playerType: this.mediaApi._v.getPlayerType()
    });
    this.dequeue();
  },
  onStopAutoplay() {
    this.setState({
      stopAutoplay: true
    });
  },
  onSelectVideo(video, index) {
    if(document.getElementById('captions') !== null) {
      document.getElementById('captions').parentNode.removeChild(document.getElementById('captions'));
    }
    if(typeof this.mediaApi === 'undefined' || typeof this.mediaApi._v === 'undefined') {
      return null;
    }
    const videoEl = this.mediaApi._v.getMediaElement();
    videoEl.removeAttribute('crossorigin');
    while (videoEl.firstChild) {
        videoEl.removeChild(videoEl.firstChild);
    }
    if(this.mediaApi && !isMobile()) {
      this.setVideoTime.call(this, 0, this.mediaApi);
      this.mediaApi.autoplay = video.autoplay;
      this.mediaApi._config.autoplay = video.autoplay;
    }
    if(!this._isReady) {
      this.enqueue('onSelectVideo', video, index);
      return null;
    }
    this.mediaApi._v.setAutoplay(video.autoplay);
    this.mediaApi.setMedia(video);
    // window.mediaApi = this.mediaApi;
    this.setState({
            index: index,
             meta: video,
        isPlaying: video.autoplay,
        isLoading: false,
          isEnded: false,
            event: 'videoSelected',
      currentTime: 0
    });
    window.trackingEnabled = false;
    s_md.pageName = (document.location.host.replace('www.', '') + document.location.pathname);
    s_md.eVar1    = (document.location.host.replace('www.', '') + document.location.pathname);
    s_md.pageURL  = (document.location.href);
    s_md.prop7    = (document.location.pathname.substring(1));
  },
  setVideoTime: throttle((newTime, mediaApi)=> {
      if(mediaApi) {
        mediaApi.setCurrentTime(newTime);
      }
    }, 500,  {
     'leading': true,
    'trailing': false
  }),
  onSetCurrentTime(time) {
    if(isIpad() && !this.state.hasStarted) {
      this.mediaApi.play();
    }
    const meta = DescriptorStore.getVideo(this.state.index);
    this.clearQueue('onSetCurrentTime');
    this.setVideoTime.call(this, time, this.mediaApi);
    if(!this.state.isPlaying) {
      this.enqueue('onSetCurrentTime', time);
      this.setState({
              event: 'settingTime',
         pushedTime: time,
        currentTime: time,
          isLoading: true,
           duration: meta.duration
      });
      return;
    }
    // on the first load of a video, the duration isn't set and
    // setting the current time doesn't work until the player has
    // started. Because Akamai makes shitty, fragile APIs. This also
    // has the effect of setting the time optimistically. `pushedTime`
    // is cleared by the progress event.
    this.setState({
            event: 'settingTime',
       pushedTime: time,
      currentTime: time,
        isLoading: true,
         duration: this.mediaApi.getDuration()
    });
  },
  onBuffering() { },
  onProgress() {
    let bufferredEnd = null;
    if(this.mediaApi._v.getMediaElement().readyState === 4) {
      bufferredEnd = this.mediaApi._v.getMediaElement().buffered.end(this.mediaApi._v.getMediaElement().buffered.length - 1);
    }
    this.setState({
            event: 'progress',
      isBuffering: false,
        isLoading: false,
       hasStarted: this.mediaApi.getCurrentTime() !== 0,
      // WARNING: this is commented out because the video api sends a
      // bogus 'progress' event after the video has been paused.
      // Don't set isPlaying to true inside this setState call.
      // isPlaying:   true, <---- don't do this.
      // Hopefully that will save you some debugging time in the future.
       pushedTime: null,
      currentTime: this.mediaApi.getCurrentTime(),
         duration: this.mediaApi.getDuration(),
      bufferredEnd: bufferredEnd
    });
  },
  onSetVolume(volume) {
    this.mediaApi._v.setVolume(volume);
  },
  onVolumeChanged() {
    this.setState({
              event: 'volumeChanged',
      currentVolume: this.mediaApi.getVolume()
    });
  },
  onMute() {
    this.onSetVolume(0);
  },
  onUnmute(volume) {
    this.onSetVolume(volume);
  },
  onSetClosedCaptioning(turnOn) {
    if(turnOn) {
      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
      this.mediaApi.turnClosedCaptionOn();
    } else {
      this.mediaApi.setCaptionLanguage('', false);
      this.mediaApi.turnClosedCaptionOff();
    }
    this.setState({
      isCaptioningOn: turnOn
    });
  },
  onSelectLanguage(lang) {
    if(lang !== '') {
      this.mediaApi.setCaptionLanguage(lang, true);
      this.setState({
        ccLang: lang,
        isOpen: false
      });
    } else {
      this.setState({
        ccLang: lang,
        isOpen: false
      });
    }
  },
  onEnd() {
  },
  onEnded() {
    this.mediaApi.end();
    this.state.viewed[this.state.index] = true;
    this.setState({
      isPlaying: false,
        isEnded: true,
          event: 'ended'
    });
    const index = (this.state.index === -1)? 1: this.state.index + 1;
    const nextVideo = DescriptorStore.getVideo(index);
    if(!nextVideo.autoplay) {
      this.mediaApi._v.config.autoplay = nextVideo.autoplay;
      this.mediaApi._config.autoplay = nextVideo.autoplay;
      this.mediaApi._config.media.autoplay = nextVideo.autoplay;
    }
    if(typeof nextVideo !== 'undefined') {
      const basePath = isLocal()? '': `/mtv/${window.MedscapeTVInstance.seriesUrlFragment}`;
      browserHistory.push(`${basePath}/${nextVideo.videoUrlFragment}`);
    }
  },
  onReplay() {
    window.trackingEnabled = false;
    this.mediaApi.replay();
    // the duration gets wiped after the video ends so we have to go back to the config.
    this.setState({
       isPlaying: true,
        duration: this.getDuration(true),
      hasStarted: true, // always true after the first start
         isEnded: false,
         canPlay: false
    });
  },
  onStart() {
    this.mediaApi.play();
    if(!this._isReady) {
      this.enqueue('onStart');
      return;
    }
    this.setState({
      event: 'start',
      isPlaying: true,
      hasStarted: true, // always true after the first start
      isLoading: true,
      isEnded: false,
      canPlay: false
    });
  },
  onCanPlay() {
  },
  onStarted() {
    const progressPoster = get(this, 'state.meta.progressPoster', null);
    if(progressPoster !== null && !(isMobile() && !isIpad())) {
      document.querySelector('.akamai-poster-image').setAttribute('src', progressPoster);
      if(progressPoster === '') {
        document.querySelector('.akamai-poster-image').style.display = 'none';
      }
    }
    this.loadMobileCC(this.state.index);
    this.dequeue();
    this.setState({
          isPlaying: true,
          isLoading: false,
            isEnded: false,
              event: 'play',
         hasStarted: true,
      currentVolume: this.mediaApi.getVolume()
    });
    if(this.state.isCaptioningOn && (!isMobile() || isIpad())) {
      this.mediaApi.setCaptionLanguage(this.state.ccLang, true);
      this.mediaApi.turnClosedCaptionOn();
    }
  },
  onToggle() {
    if(this.isPlaying()) {
      this.onPause();
    } else {
      this.onStart();
    }
  },
  getIndex() {
    return this.state.index;
  },
  /* accessors */
  isPlaying() {
    return this.state.isPlaying;
  },
  getCurrentTime() {
    if(!this._isReady) return 0;
    return this.mediaApi.getCurrentTime();
  },
  getDuration() {
    return this.mediaApi.getDuration();
  },
  getVideoUrlFragment() {
    return get(this, 'state.meta.videoUrlFragment', '');
  },
  getSeriesTitle() {
    return DescriptorStore.state.seriesUrlFragment;
  },
  getTitle() {
    return DescriptorStore.getTitle(this.state.index);
  },
  getVersion() {
    return 'Medscape/AMP';
  }
});



/** WEBPACK FOOTER **
 ** ./modules/stores/video_store.js
 **/